export default {"src":"/_next/static/media/artifactory.c51f67d2.svg","height":74,"width":68};